import documentApiClient, { ApiDefinition } from '@documentsApi';

type ThisApi = ApiDefinition['/document-request-users/{documentRequestUserId}/userWorkflow/{userWorkflowId}/means-test']['GET'];
type Input = ThisApi['params'];

const getMeansTestData = async ({ documentRequestUserId, userWorkflowId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get(`/document-request-users/${documentRequestUserId}/userWorkflow/${userWorkflowId}/means-test`);
  return response.data;
};

export default getMeansTestData;
